import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4ZM11.067 15.5589L12.9999 17.0794L13.2548 15.9339L11.7291 14.2019C11.4161 13.9182 11.584 13.3802 11.9957 13.346L14.2535 13.1453L15.1368 10.969C15.296 10.5725 15.8379 10.5725 15.9971 10.969L16.1841 11.4309L17.3033 10.4163C17.8126 9.95535 17.5391 9.08084 16.8702 9.02518L13.2012 8.69949L11.7657 5.15457C11.6343 4.82694 11.3423 4.66629 11.0528 4.67166C10.7725 4.67703 10.4952 4.83817 10.3682 5.15457L8.93268 8.69168L5.26373 9.01736C4.59478 9.07303 4.32135 9.94754 4.83062 10.4085L7.61822 12.9358L6.78277 16.6873C6.72076 16.9661 6.80133 17.221 6.95807 17.4002C7.18561 17.6609 7.57281 17.7625 7.91461 17.5457L11.067 15.5589ZM17.3333 18.0001L15.8783 17.0794L14.4233 17.9965C14.1569 18.1652 13.8308 17.9158 13.901 17.6003L14.2866 15.8688L12.9999 14.7022C12.765 14.4895 12.8913 14.0859 13.1998 14.0603L14.8931 13.9099L15.5558 12.2774C15.675 11.9803 16.0816 11.9803 16.2008 12.2774L16.8635 13.9135L18.5568 14.0639C18.8653 14.0896 18.9916 14.4931 18.7567 14.7059L17.47 15.8725L17.8556 17.604C17.9258 17.9194 17.5997 18.1689 17.3333 18.0001Z",
      fill: "#2C3647"
    }, null, -1)
  ]))]))
}
export default { render: render }